import styled from 'styled-components';

export const SuccessContainer = styled.div`
  width: 557px;
  border-radius: 5px;
  margin: 4rem auto;
  background-color: ${({ theme }) => theme.white.a10};
  justify-self: center;
  padding: 4em;
  font-size: 1.6em;
  color: ${({ theme }) => theme.baseBlue.a10};
  text-align: center;
`;

export const ButtonContainer = styled.div`
  margin-top: 15px;
`;
